import { useMutation } from "@tanstack/react-query";

import { processRequest } from "@api/config";
import { privateRequestAPI } from "@api/privateRequests";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const usePrivateRequestListQuery = () => {
	const query = useAuthQuery({
		queryKey: [QUERY_KEYS.PRIVATE_REQUEST_DATA],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_PRIVATE_REQUEST_LIST,
				request: (token) => privateRequestAPI.getPrivateRequestAsync({ token }),
			});

			return data;
		},
	});

	if (query.isSuccess) {
		return query.data;
	}

	return [];
};

export const usePrivateRequestAcceptMutation = () =>
	useMutation({
		mutationFn: async (userId: number) => {
			await processRequest({
				prefix: API_PREFIXES.PRIVATE_REQUEST_ACCEPT,
				request: (token) => privateRequestAPI.privateRequestAcceptAsync({ token, userId }),
			});
		},
	});

export const usePrivateRequestDeclineMutation = () =>
	useMutation({
		mutationFn: async (userId: number) => {
			await processRequest({
				prefix: API_PREFIXES.PRIVATE_REQUEST_DECLINE,
				request: (token) => privateRequestAPI.privateRequestDeclineAsync({ token, userId }),
			});
		},
	});
